<app-spare-parts-datepicker
  [dateRange]="dateRange()"
  (dateRangeChange)="onDateRangeChange($event)"
  [allowedYearsRange]="3"
></app-spare-parts-datepicker>

<div class="input-wrapper">
  <div class="icon-wrapper">
    @if (modalCount > 0) {
      <sh-text>({{ modalCount }})</sh-text>
    }
    <sh-icon
      button
      id="spare-parts-filter-popover"
      size="m"
      icon="filter"
      color="#7D7D7D"
      (click)="onFilterClick()"
      (keydown.enter)="onFilterClick()"
      (keydown.backspace)="onFilterClick()"
      [disabled]="disableModal()"
    ></sh-icon>

    @if (popoverVisibility) {
      <app-spare-parts-filter-popover
        targetId="spare-parts-filter-popover"
        position="bottom-right"
        [modalFilters]="this.filter().modalFilters"
        (cancelChange)="popoverVisibility = false"
        (modalFiltersChange)="
          onModalFiltersChange($event); popoverVisibility = false
        "
      >
      </app-spare-parts-filter-popover>
    }
  </div>
  <sh-input-text
    #searchInput
    id="spare-parts-filter-search-input"
    label="{{ 'spareParts.search' | translate }}"
    [value]="filter().searchInput"
    (value-changed)="onInputChange(searchInput.value)"
    [disabled]="disableSearch()"
  >
    <sh-icon icon="search" size="s" slot="icon"></sh-icon>
  </sh-input-text>
</div>
